module.exports = __webpack_public_path__ + "e170c5c21ccbf0cb2bb3654cff4378eb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/UY.svg
// module id = UosC
// module chunks = 0